var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('modal',{ref:"modal",attrs:{"dark":""}},[_c('div',{attrs:{"id":"sub-wrapper"}},[_c('div',{staticClass:"from"},[_vm._v(_vm._s(_vm.message.from))]),_c('div',{staticClass:"message"},[_vm._v(_vm._s(_vm.message.message))])])])}
var staticRenderFns = []

export { render, staticRenderFns }